<template>
	<div class="container mt-8">
		<h1 class="text-center mb-2">{{ golfRoundData.title }}</h1>
		<div class="filter-bar flex justify-center mt-2 mb-4">
			<button
				:class="{'mgs-selected-button': mode === 'editForm'}"
				@click="mode = 'editForm'"
				class="mgs-button button mx-1"
				:key="`round-edit-editForm`"
			>DETAILS</button>
			<button
				:class="{'mgs-selected-button': mode === 'scorecard'}"
				@click="mode = 'scorecard'"
				class="mgs-button button mx-1"
				:key="`round-edit-scorecard`"
			>SCORECARD</button>
			<button
				:class="{'mgs-selected-button': mode === 'statistics'}"
				@click="mode = 'statistics'"
				class="mgs-button button mx-1"
				:key="`round-edit-statistics`"
			>STATISTICS</button>
		</div>

		<div class="mt-8">
			<div class="mgs-page-block bg-white p-4" v-show="mode === 'editForm'">
				<round-form :golf-round="golfRoundData" @round-saved="roundSaved"></round-form>
			</div>
			<div class="mgs-page-block" v-show="mode === 'scorecard'">
				<course-scorecard
					v-model="golfRoundData"
					@round-saved="roundSaved"
					:golf-course="roundGolfCourse"
					:scorecard-holes="golfRoundData.holes"
					:course-tee="golfRoundData.tee"
				></course-scorecard>
			</div>
			<div class="mgs-page-block" v-show="mode === 'statistics'">
				<round-statistics :golf-round="golfRoundData"></round-statistics>
			</div>
		</div>
	</div>
</template>
<script>
/** @format */
import CourseFields from '@/fields/courses';
export default {
	name: 'RoundsEdit',
	props: {
		golfRound: {
			type: Object,
			required: true
		}
	},
	components: {
		'round-form': () => import(/* webpackChunkName: "RoundForm" */ './../components/Forms/Round'),
		'course-scorecard': () => import(/* webpackChunkName: "CourseScorecard" */ './../components/Course/Scorecard'),
		'round-statistics': () => import(/* webpackChunkName: "RoundStatistics" */ './../components/Round/Statistics')
	},
	methods: {
		scorecardUpdate(data) {},
		roundSaved(golfRoundData) {
			this.golfRoundData = Object.assign(this.golfRoundData, golfRoundData);
		}
	},
	data() {
		return {
			mode: 'editForm',
			golfRoundData: this.golfRound,
			roundGolfCourse: this.golfRound.course
		};
	}
};
</script>
